module.exports = __webpack_public_path__ + "static/media/trinity-brand-commercial-services-ltd.2a2f93c5.png";